// Package Imports
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';

// Project Imports
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import PrivateRouteConst from 'core/common/privateRouteConstant';
import Loading from 'components/loading/loading';
import RulesCreate from 'pages/rules/RulesCreate';

const RulesList = lazy(() => import('pages/rules/rulesList'));
// const RulesEdit = lazy(() => import('pages/rules/RulesEdit'));

const RulesRoute = (
  <Route path={routeName.rules}>
    <Route
      index
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.RULES_VIEW,
            PrivateRouteConst.SELF_RULES_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <RulesList />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="create"
      element={
        <PrivateRoute name={PrivateRouteConst.CREATE_RULE}>
          <Suspense fallback={<Loading />}>
            <RulesCreate type="Create" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="edit/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.RULES_EDIT,
            PrivateRouteConst.SELF_RULES_EDIT,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <RulesCreate type="Edit" />
          </Suspense>
        </PrivateRoute>
      }
    />
    <Route
      path="show/:id"
      element={
        <PrivateRoute
          name={[
            PrivateRouteConst.RULES_VIEW,
            PrivateRouteConst.SELF_RULES_VIEW,
          ]}
        >
          <Suspense fallback={<Loading />}>
            <RulesCreate type="Show" />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default RulesRoute;
